function DesktopHeaderSetting() {
    if (!isMobileResolution()) {
        $(".nav-menu .menu-list > li").on({
            mouseenter:
                function () {
                    if ($(this).find(".itemsWrapper").length > 0 && !$("#RegisterLoginModal").is(":visible")) {
                        $("body").addClass("BackDropped");
                    }

                    if (!isMobileResolution()) {
                        $(this).addClass("is-open");
                        $(".backdrop").addClass("active");
                        $(this).closest(".nav-container").addClass("is-open");
                        $(this).find(".mega-menu").css("height", "calc(-83px + 80vh)");


                        // Manuel lazy loading - picture elementleri için
                        $(this).find(".mega-menu picture").each(function () {
                            var $picture = $(this);

                            // Source etiketlerini yükle
                            $picture.find("source[data-srcset]").each(function () {
                                var $source = $(this);
                                if (!$source.attr("srcset-loaded")) {
                                    $source.attr("srcset", $source.attr("data-srcset"));
                                    $source.attr("srcset-loaded", "true");
                                }
                            });

                            // Img etiketini yükle
                            var $img = $picture.find("img.manual-lazy");
                            var dataSrc = $img.attr("data-src");

                            if (dataSrc && !$img.attr("src-loaded")) {
                                $img.attr("src", dataSrc);
                                $img.attr("src-loaded", "true");
                            }
                        });
                    }
                },
            mouseleave:
                function () {
                    if ($(".SearchModal").css("display") != "block") {
                        $("body").removeClass("BackDropped");
                    }

                    if (!isMobileResolution()) {
                        $(this).removeClass("is-open");
                        $(".backdrop").removeClass("active");
                        $(this).closest(".nav-container").removeClass("is-open");
                        $(this).find(".mega-menu").css("height", "0");
                    }
                }
        });

        $(".mega-menu-container").removeClass("container");
    }
}

function searchSetting() {
    $(document).on("click", ".js-header-search:not(.is-search-expanded)", function () {
        $(".nav-container").addClass("is-search-expanded");
        $(".js-header-search").addClass("is-search-expanded");

        var width = ($(".nav-container #Logo").width() + 1) + "px";

        $(".nav-container .header-search-form .search-input").focus();
        $(".nav-container .header-search-form").css("transform", "translateX(" + width + ")");
        $(".nav-container .header-search-form").css("width", "calc(100% - " + width + ")");
        $(".nav-container .header-search-form").css("position", "absolute");
        $(".nav-container .header-search-form").css("top", "0");
        $(".nav-container .header-search-form").css("left", "0");
        $(".nav-container .header-search-form").css("z-index", "1");
    });

    $(document).on("click", ".js-header-search-close", function () {
        $(".nav-container").removeClass("is-search-expanded");
        $(".js-header-search").removeClass("is-search-expanded");

        $(".nav-container .header-search-form").css("transform", "");
        $(".nav-container .header-search-form").css("width", "");
        $(".nav-container .header-search-form").css("position", "");
        $(".nav-container .header-search-form").css("top", "");
        $(".nav-container .header-search-form").css("left", "");
        $(".nav-container .header-search-form").css("z-index", "");
    });
}

function mobileMenuSetting() {
    var bodyStyles = document.body.style;
    bodyStyles.setProperty('--window-height', $(window).height() + "px");

    if ($(".js-menu-navigation .mega-menu-container .LeftContent > .has-image").length > 0) {
        $(".js-menu-navigation .mega-menu-container .LeftContent > .has-image").each(function (index) {
            $(this).parent().addClass("flyout-image");
        });
    }

    $(document).on("click", ".js-icon-burger", function () {
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(".js-menu-navigation").css("height", "0");
            backdropControl("hide");
        }
        else {
            $(this).addClass("active");
            MobileFilterOperation("hide");
            $(".js-menu-navigation").css("height", "clamp(450px, 78dvh, 625px)");
            backdropControl("show");
        }
    });

    $(document).on("click", ".navigation_link", function () {
        var item = $(this);

        if (item.parent().find(".mega-menu").length > 0) {
            event.preventDefault();
            $(this).find("~ .mega-menu").addClass("active");

            // Manuel lazy loading - picture elementleri için
            $(this).find("~ .mega-menu picture").each(function () {
                var $picture = $(this);

                // Source etiketlerini yükle
                $picture.find("source[data-srcset]").each(function () {
                    var $source = $(this);
                    if (!$source.attr("srcset-loaded")) {
                        $source.attr("srcset", $source.attr("data-srcset"));
                        $source.attr("srcset-loaded", "true");
                    }
                });

                // Img etiketini yükle
                var $img = $picture.find("img.manual-lazy");
                var dataSrc = $img.attr("data-src");

                if (dataSrc && !$img.attr("src-loaded")) {
                    $img.attr("src", dataSrc);
                    $img.attr("src-loaded", "true");
                }
            });
        }
    });

    $(document).on("click", ".subcategory-title", function () {
        if ($(this).find("+ .sublinks").length > 0) {
            event.preventDefault();
            $(this).closest(".mega-menu").find("> .js-link-back").addClass("d-none");
            $(this).find("~ .sublinks").addClass("active");
        }
    });

    $(document).on("click", ".js-link-back", function () {
        if ($(this).parent(".sublinks.active").length > 0) {
            $(this).closest(".sublinks").removeClass("active");
            $(this).closest(".mega-menu").find("> .js-link-back").removeClass("d-none");
        }
        else
            $(this).closest(".mega-menu").removeClass("active");
    });
}

$(document).ready(function () {
    DesktopHeaderSetting();
    searchSetting();

    if (isMobileResolution())
        mobileMenuSetting();

    $(document).on("click", ".js-mini-cart-link", function () {
        if ($("body").hasClass("checkout")) return;

        toggleBasket();
    });

    $(document).on("click", ".js-close-mini-cart", function () {
        hideBasket();
    });
});